import { createSelector } from 'reselect';

import { StateDictionary } from '../reducers/utils/state-manager';

export type HrisIntegrationResponseState = {
  hrisIntegrationResponsesByOrgId: { [orgId: number]: HrisIntegrationResponse };
  hrisIntegrationResponsesStateByOrgId: StateDictionary;
};
type State = { hrisIntegrationResponses: HrisIntegrationResponseState };

const hrisIntegrationResponsesByOrgIdSelector = (state: State) =>
  state.hrisIntegrationResponses.hrisIntegrationResponsesByOrgId;
const hrisIntegrationResponsesSelector = createSelector(
  [hrisIntegrationResponsesByOrgIdSelector],
  (hrisIntegrationResponsesByOrgId) => hrisIntegrationResponsesByOrgId,
);

export const hrisIntegrationResponseForOrgIdSelector = createSelector(
  [hrisIntegrationResponsesSelector, (_state: State, orgId: number) => orgId],
  (hrisIntegrationResponsesByOrgId, orgId) => hrisIntegrationResponsesByOrgId[orgId],
);

const hrisIntegrationResponsesStateByOrgIdSelector = (state: State) =>
  state.hrisIntegrationResponses.hrisIntegrationResponsesStateByOrgId;
export const hrisIntegrationResponsesStateForOrgIdSelector = createSelector(
  [hrisIntegrationResponsesStateByOrgIdSelector, (_state: State, orgId: number) => orgId],
  (hrisIntegrationResponsesStateByOrgId, orgId) => hrisIntegrationResponsesStateByOrgId[orgId],
);
